#import "./user-fragment.graphql"
#import "./origin-fragment.graphql"
#import "./contact-fragment.graphql"
#import "./activity-fragment.graphql"
#import "./note-fragment.graphql"
#import "./submission-fragment.graphql"
#import "./account-fragment.graphql"
#import "./lead-fragment.graphql"
#import "./chat-fragment.graphql"
#import "./assignment-fragment.graphql"
#import "./constant-contact-contact-tracking-activity-fragment.graphql"
#import "./entity-attribute-value-file-fragment.graphql"
#import "./comment-banner-fragment.graphql"
#import "./session-fragment.graphql"
#import "./ma-url-fragment.graphql"

#import "./full/email-fragment-full.graphql"
#import "./full/email-queued-fragment-full.graphql"
#import "./full/email-interaction-fragment-full.graphql"

#import "../../reactions/graphql/fragments/reaction-fragment.graphql"
#import "../../comments/graphql/fragments/comment-fragment.graphql"

fragment EventFragmentFull on TimelineEvent {
    id
    changeType
    actor {
        ... on User {
            ...UserFragment
        }
        ... on Origin {
            ...OriginFragment
        }
        ... on Contact {
            ...ContactFragment
        }
        ... on Account {
            ...AccountFragment
        }
        ... on MaUrl {
            ...MaUrlFragment
        }
    }
    payload {
        ... on Activity {
            ...ActivityFragment
        }
        ... on Note {
            ...NoteFragment
        }
        ... on Email {
            ...EmailFragmentFull
        }
        ... on EmailQueued {
            ...EmailQueuedFragmentFull
        }
        ... on Origin {
            ...OriginFragment
        }
        ... on Submission {
            ...SubmissionFragment
        }
        ... on Account {
            ...AccountFragment
        }
        ... on Contact {
            ...ContactFragment
        }
        ... on Lead {
            ...LeadFragment
        }
        ... on Chat {
            ...ChatFragment
        }
        ... on Assignment {
            ...AssignmentFragment
        }
        ... on EmailInteraction {
            ...EmailInteractionFragmentFull
        }
        ... on ConstantContactContactTrackingActivity {
            ...ConstantContactContactTrackingActivityFragment
        }
        ... on EntityAttributeValueFile {
            ...EntityAttributeValueFileFragment
        }
        ... on Comment {
            ...CommentBannerFragment
        }
        ... on Session {
            ...SessionFragment
        }
    }
    changeTime
    changes {
        id
        attribute
        oldValue
        newValue
    }
    files {
        ...EntityAttributeValueFileFragment
    }
    reactions {
        ...ReactionFragment
    }
    comments {
        ...CommentFragment
    }
    count
}
